import BossModel from "@/models/BossModel";

export default class InfoLine extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'country/info-line';

    /**
     *
     * @type {string}
     */
    static entity = 'countryInfoLines';

    static fields() {
		return {
			id: this.number(null).nullable(),
			rank: this.number(null).nullable(),
			title: this.attr(null),
			text: this.attr(null),
			country_id: this.number(null).nullable(),
		}
	}
}
